import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-wait-time-banner',
  templateUrl: './wait-time-banner.component.html',
  styleUrls: ['./wait-time-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaitTimeBannerComponent {
  @Input() message = '';
  @Input() short = false;
}
